<div id="errorMsg" class="row">
    <div id="errorMsgMain">Oops! Something went wrong.</div>
    <div>We couldn’t load the list of thesauri. Please refresh this page or try again later. If the problem continues, <a href="{{supportUrl}}" target="_blank">contact support</a> for assistance.</div>
</div>
